import { render, staticRenderFns } from "./LessonItem.vue?vue&type=template&id=4b115656&scoped=true&"
import script from "./LessonItem.vue?vue&type=script&lang=js&"
export * from "./LessonItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b115656",
  null
  
)

export default component.exports